import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'

export default class MainHeader {
  constructor() {
    this.el = document.querySelector('.js-header')
    this.scrollViews = this.el.querySelectorAll('[data-prevent-scroll-lock]')

    this.el.addEventListener('A11yPopupOpen', () => {
      this.scrollViews.forEach((scrollView) => {
        disableBodyScroll(scrollView)
      })
    })

    this.el.addEventListener('A11yPopupClose', () => {
      this.scrollViews.forEach((scrollView) => {
        enableBodyScroll(scrollView)
      })
    })
  }
}
